import { PLAYER_POSITION_LEASE_MS } from '@repo/map-preferences/types';

export class PlayerPositionLease {
    readonly #onExpired: () => void;
    readonly #leaseMs: number;
    #timeout: ReturnType<typeof setTimeout> | null = null;

    public constructor(onExpired: () => void, leaseMs = PLAYER_POSITION_LEASE_MS) {
        this.#onExpired = onExpired;
        this.#leaseMs = leaseMs;
    }

    public refresh(): void {
        this.dispose();
        this.#timeout = setTimeout(() => {
            this.#timeout = null;
            this.#onExpired();
        }, this.#leaseMs);
    }

    public expire(): void {
        this.dispose();
        this.#onExpired();
    }

    public dispose(): void {
        if (this.#timeout === null) return;
        clearTimeout(this.#timeout);
        this.#timeout = null;
    }
}
